import { render, staticRenderFns } from "./UniformDetailForm.vue?vue&type=template&id=3132a5b8&scoped=true"
import script from "./UniformDetailForm.vue?vue&type=script&lang=js"
export * from "./UniformDetailForm.vue?vue&type=script&lang=js"
import style0 from "./UniformDetailForm.vue?vue&type=style&index=0&id=3132a5b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132a5b8",
  null
  
)

export default component.exports